import $ from 'jquery';
import View from 'mixins/view';
import { repository } from 'repositories/loadCommentsAsync';
import CommentView from 'ui/comments/home/comment-view';
import { buildCommentSocioTippies } from '@ui/comments/comment-socio-view';

const elements = {
    container: '.c-comments-main-box',
    loadMore: '.c-comments__home-loadMore',
    comment: 'article.user-comment',
};

export default class extends View {
    constructor(model) {
        super(model);
        this.setRootEl($(elements.container));
        model.addEventListener('commentsAdded', this.update.bind(this));
        this.lastCommentId = null;
        buildCommentSocioTippies(elements.container);
    }
    update(comments) {
        if (comments.length) {
            comments.forEach(this.addComment.bind(this));
            this.lastCommentId = this.getLastCommentId(comments);
        } else {
            this.rootEl.find(elements.loadMore).addClass('fn-hidden');
        }
    }
    getLastCommentId(comments) {
        const comment = (comments.length > 0) ? comments[comments.length - 1] : null;
        return comment ? comment.get('id') : null;
    }
    addComment(model) {
        const commentView = new CommentView(model);
        this.addChild(commentView);
        commentView.render();
        commentView.initLinkAction();

        const $loadMoreButton = this.rootEl.find(elements.loadMore);
        if ($loadMoreButton.length) {
            $loadMoreButton.before(commentView.getRootEl());
        } else {
            this.rootEl.append(commentView.getRootEl());
        }
    }
    initCommentsCollection() {
        const collection = this.getModel();
        let comments = (window.__madridismoComments__ || {}).comments;

        if (comments === void(0)) {
            comments = [];
        }
        collection.fromJSON(comments);
        this.lastCommentId = this.getLastCommentId(collection.get('comments'));
        return collection;
    }
    loadMoreComments() {
        repository.loadRaw(this.lastCommentId).then(data => {
            const commentsCollection = this.getModel();
            commentsCollection.addComments(data.comments);
        });
    }
    render() {
        const commentsCollection = this.initCommentsCollection();
        const comments = commentsCollection.get('comments');

        comments.forEach(this.addComment.bind(this));

        if (comments.length) {
            $(elements.loadMore).on('click', event => {
                event.preventDefault();
                this.loadMoreComments();
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/comments/home/comments-container-view.js